
import state from './moduleIntegracaoState.js'
import mutations from './moduleIntegracaoMutations.js'
import actions from './moduleIntegracaoActions.js'
import getters from './moduleIntegracaoGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
